/**
 * @nanokart/tryon-studio-sdk
 * useStore hook - Access the Zustand store from context
 */

import { useContext } from 'react';
import { useStore as useZustandStore } from 'zustand';
import { TryOnContext } from '../TryOnProvider';
import type { TryOnStore } from '../state/types';

/**
 * Access the TryOn store from context
 * Must be used within TryOnProvider
 */
export function useStore<T>(selector: (state: TryOnStore) => T): T {
  const store = useContext(TryOnContext);
  
  if (!store) {
    throw new Error('useStore must be used within TryOnProvider');
  }
  
  return useZustandStore(store, selector);
}

/**
 * Get the entire store (use sparingly - prefer selectors)
 */
export function useTryOnStore(): TryOnStore {
  const store = useContext(TryOnContext);
  
  if (!store) {
    throw new Error('useTryOnStore must be used within TryOnProvider');
  }
  
  return useZustandStore(store, (state) => state);
}
